import {
  Checkbox as ChakraCheckbox,
  Flex,
  FlexProps,
  Icon,
  SystemStyleObject,
  Text,
} from '@chakra-ui/react'
import React, { ChangeEvent, useState } from 'react'
import CheckedIcon from '~/assets/svgs/icon-checkbox-checked.svg?react'
import UncheckedIcon from '~/assets/svgs/icon-checkbox-unchecked.svg?react'
import { useCheckboxStyles } from '~/components/shared/componentStyles/Checkbox.style'
import { Size } from '~/types/ThemeTypes'

export interface CheckboxProps
  extends Omit<FlexProps, 'onChange' | 'label' | 'defaultChecked' | 'textSx'> {
  defaultChecked?: boolean
  onChange: (value: boolean) => void
  label: string
  textSx?: SystemStyleObject
}

const CustomCheckbox = ({ isChecked }: { isChecked?: boolean }) => {
  const styles = useCheckboxStyles()
  return isChecked ? (
    <Icon as={CheckedIcon} sx={styles.checkbox} />
  ) : (
    <Icon as={UncheckedIcon} sx={styles.checkbox} />
  )
}

export const Checkbox = ({
  defaultChecked,
  label,
  onChange,
  textSx,
  ...rest
}: CheckboxProps) => {
  const styles = useCheckboxStyles()
  const [isChecked, setIsChecked] = useState(defaultChecked)

  const handleClicked = (e: ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked
    setIsChecked(isChecked)
    onChange(isChecked)
  }

  return (
    <Flex data-group sx={styles.container} {...rest}>
      <ChakraCheckbox
        icon={<CustomCheckbox />}
        size={Size.lg}
        defaultChecked={defaultChecked}
        isChecked={isChecked}
        spacing={'0.5rem'}
        onChange={handleClicked}
      >
        <Text sx={{ ...styles.text, ...textSx }}>{label}</Text>
      </ChakraCheckbox>
    </Flex>
  )
}
